module.exports = __webpack_public_path__ + "img/weatherpedia-pwa2.2a16a049.jpg";